import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { Hyperlink } from '@xing-com/hyperlink';
import {
  spaceXXS,
  spaceXS,
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { BodyCopy, Hero } from '@xing-com/typography';

export const TopArea = styled.div`
  margin-bottom: ${spaceXXL};
`;

export const Header = styled.div`
  margin-bottom: ${spaceXXL};
`;

export const DialogContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const TopAreaHeader = styled(Hero)`
  margin-bottom: 20px;
`;

export const TopAreaBody = styled(BodyCopy)`
  margin-bottom: 20px;
`;

export const PremiumButtonWrapper = styled.div`
  margin-bottom: 20px;
  padding-inline: ${spaceXXS};
`;

export const PremiumButton = styled(Button)`
  width: calc(100% - ${spaceXS});
  margin-left: ${spaceXXS};
`;

export const BottomArea = styled.div`
  margin-top: ${spaceL};
`;

export const BottomAreaContent = styled.div<{ $open: boolean }>`
  display: ${({ $open }) => ($open ? 'block' : 'none')};
`;

export const Footer = styled.footer`
  color: ${xdlColorTextSecondary};
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceXL};
  margin-top: ${spaceM};

  & a,
  & a:visited {
    color: ${xdlColorTextSecondary};
  }
`;

export const Paragraph = styled(BodyCopy)`
  margin-bottom: ${spaceM};
`;

export const Title = styled.span`
  display: block;
  font-weight: bold;
`;

export const Divider = styled.span`
  border-top: 1px solid currentcolor;
  display: block;
  margin-top: ${spaceS};
  margin-bottom: ${spaceS};
`;

export const Link = styled(Hyperlink)`
  text-decoration: none;
`;
